import React, { useState } from 'react';
import { Marker, Popup, useMapEvents } from 'react-leaflet';
import { DivIcon } from 'leaflet';
import { useSearchBox, useGeoSearch } from 'react-instantsearch';
import {contactModal} from './contactModal';

export function Reps() {

    const { query, refine: refineQuery } = useSearchBox();
    const { items, refine: refineItems, currentRefinement, clearMapRefinement, } = useGeoSearch();
    const [previousQuery, setPreviousQuery] = useState(query);
    const [skipViewEffect, setSkipViewEffect] = useState(false);
    
    // When the user moves the map, we clear the query if necessary to only
    // refine on the new boundaries of the map.

    const onViewChange = ({ target }) => {
        setSkipViewEffect(true);
        if (query.length > 0) {
            refineQuery('');
        }
        refineItems({
            northEast: target.getBounds().getNorthEast(),
            southWest: target.getBounds().getSouthWest(),
        });
    };

    const map = useMapEvents({
        zoomend: onViewChange,
        dragend: onViewChange,
    });

    // When the query changes, we remove the boundary refinement if necessary and
    // we center the map on the first result.

    if (query !== previousQuery) {

        if (currentRefinement) {
            clearMapRefinement();
        }
        // `skipViewEffect` allows us to bail out of centering on the first result
        // if the query has been cleared programmatically.
        if (items.length > 0 && !skipViewEffect) {
            map.setView(items[0]._geoloc);
        }
        setSkipViewEffect(false);
        setPreviousQuery(query);
    }


    return (<>
      {items.map((rep) => (<Marker key={rep.objectID} position={rep._geoloc} icon={createMarker(rep)}  eventHandlers={{ click: (e) => { map.flyTo(e.latlng, map.getZoom() >= 8 ? map.getZoom() : 8 ),{'animate':true,'duration':0.75}} }}>
          <Popup>
            <div className="p-2 text-base font-body">
                <div className="sm:min-w-[300px]"></div>
                <h5 className="text-lg lg:text-xl font-medium text-brand-blue-900">{rep.state}</h5>
                { rep.area && 
                    <div className="text-xs md:text-sm text-brand-neutral-700 mb-2 lg:mb-4">{rep.area}</div>
                }
                { rep.company && 
                    <div className="font-bold text-sm mb-2">{rep.company}</div>
                }
                <div className="flex justify-between pt-2">
                { rep.email && 
                    <a className='button small text inline' onClick={() => { contactModal(rep) }} href="#">Contact Sales Rep</a>
                }
                { rep.phone && 
                    <a
                        className='button small text'
                        href={`tel:${rep.phone.trim()}`}
                        onClick={() => {
                            gtag('event', 'sales_rep', {
                                'company_name': `${rep.company}`,
                                'state': `${rep.state}`,
                                'event_type': 'telephone'
                            });
                        }}>{rep.phone.trim()}</a>
                }
                </div>
                
            </div>
          </Popup>
        </Marker>))}
    </>);
}


function createMarker(item) {
    return new DivIcon({
        html: `<svg class="text-brand-blue-300 hover:text-brand-blue-900 fill-current duration-200 hover:scale-105" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.667 33.333"><path fill="currentColor" fill-rule="evenodd" d="M14.932 31.743c-.53.527-1.065 1.056-1.599 1.59-.534-.534-1.068-1.063-1.598-1.59C5.64 25.701 0 20.107 0 13.333 0 5.97 5.97 0 13.333 0c7.364 0 13.334 5.97 13.334 13.333 0 6.774-5.642 12.368-11.735 18.41Zm3.401-18.41a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"/></svg>`,
        className: "",
        iconSize: [20, 25],
        popupAnchor: [0, -16],
    });
}
